var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"flex items-center justify-center h-10"},[_vm._v("\n      ©  2019  Karin Hamano\n    ")])])}]

export { render, staticRenderFns }